// extracted by mini-css-extract-plugin
export default {"about":"styles_about__y8E2I","text":"styles_text__RCTwt"};